const userRoutes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/',
        component: () => import('../layouts/Public.vue'),
        children: [
            {
                path: '/create',
                name: 'TicketCreate',
                component: () => import('../views/TicketCreate.vue')
            },
            {
                path: '/ticket/:ref',
                name: 'TicketDetails',
                component: () => import('../views/TicketDetails.vue')
            },
            {
                path: '/my-tickets',
                name: 'Tickets',
                component: () => import('../views/Tickets.vue')
            },
            {
                path: '/faq',
                name: 'Faq',
                component: () => import('../views/Faq.vue')
            },
            {
                path: '/create-anonymously',
                name: 'TicketCreateAnonymously',
                component: () => import('../views/TicketCreateAnonymously.vue')
            },
        ]
    },

]

export default userRoutes